import { gql } from '@apollo/client';

export const UpdateUserFinancing = gql`
  mutation UpdateUserFinancing($ownLender: Boolean!) {
    buyer {
      updateUserFinancing(
        input: {
          ownLender: $ownLender
          attribution: { utmCampaign: "feed", utmMedium: "web", utmSource: "bwod" }
        }
      ) {
        user {
          id
          learnMoreRequested
        }
      }
    }
  }
`;
